// extracted by mini-css-extract-plugin
export default {"root":"McpEditModal_root__RW6pJ"};